export default "__VITE_PUBLIC_ASSET__60416951__"